import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <a href="https://ipcc.ch/" target="_blank" rel="noreferrer">
          <StaticImage
            src="../img/footer/footer-left.png"
            alt=""
            className="w-100 h-100 img-fluid footer-img"
          />
        </a>
      </div>
      <div className="footer-social">
        <a
          href="https://twitter.com/IPCC_CH"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-twitter"></i>
        </a>
        <a
          href="https://www.facebook.com/IPCC/"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-facebook-square"></i>
        </a>
        <a
          href="https://www.instagram.com/ipcc/?hl=en"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-instagram"></i>
        </a>
        <a
          href="https://vimeo.com/ipcc"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-vimeo"></i>
        </a>
      </div>
    </footer>
  )
}
export default Footer
